import { createContext } from "react";

const WalletTodayMovementsContext = createContext();

export default WalletTodayMovementsContext;
